import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import EventBus from './utils/event-bus'
import Api from './utils/api'
import Helpers from './utils/helpers'

import FormField from './components/Form/FormField'
import Card from './components/General/Card/Card'
import Payment from 'payment/lib'

import BootstrapVue from 'bootstrap-vue'
import VTooltip from 'v-tooltip'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import { extendMoment } from 'moment-range'
import Multiselect from 'vue-multiselect'
import VueTheMask from 'vue-the-mask'
import VueSweetalert2 from 'vue-sweetalert2';
import DateRangePicker from 'vitorm11-cj-daterange-picker'
import datePicker from 'vue-bootstrap-datetimepicker';
import VueGoogleCharts from 'vue-google-charts'
import Loading from 'vue-loading-overlay'
import vClickOutside from 'v-click-outside'
// import VueIntercom from 'vue-intercom'
import VueTawk from 'vue-tawk'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import CpfValidator from './utils/validators/cpf/cpf.validator'
import CnpjValidator from './utils/validators/cnpj/cnpj.validator'
import pt_BR from 'vee-validate/dist/locale/pt_BR'
import draggable from 'vuedraggable'
import money from 'v-money'
import Nl2br from 'vue-nl2br'
import VueMultianalytics from 'vue-multianalytics'
import PerfectScrollbar from 'vue2-perfect-scrollbar'

import CKEditor from '@ckeditor/ckeditor5-vue2';

import 'reset-css/sass/_reset.scss'
import 'normalize.css/normalize.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import 'pretty-checkbox/dist/pretty-checkbox.css'

import 'vitorm11-cj-daterange-picker/dist/vitorm11-cj-daterange-picker.css'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

import 'vue-loading-overlay/dist/vue-loading.css'

import 'sweetalert2/dist/sweetalert2.min.css'

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.config.productionTip = false;

extendMoment(moment);
momentDurationFormatSetup(moment);
Vue.prototype.moment = moment;
Vue.prototype.moment.locale('pt-BR');
Vue.prototype.eventBus = EventBus;
Vue.prototype.api = Api;
Vue.prototype.helpers = Helpers;
Vue.prototype.sentry = Sentry;

Vue.use(BootstrapVue);
Vue.use(VTooltip);
Vue.use(VueTheMask);
Vue.use(VueSweetalert2);
Vue.use(DateRangePicker);
Vue.use(datePicker);
Vue.use(VueGoogleCharts);
Vue.use(Loading);
Vue.use(vClickOutside);
// Vue.use(VueIntercom, { appId: process.env.VUE_APP_INTERCOM_ID });
Vue.use(VueTawk, { tawkSrc: process.env.VUE_APP_TAWK_SRC });
Vue.use(money, { prefix: 'R$ ', thousands: '.', decimal: ',', masked: true });
Vue.use(PerfectScrollbar);
Vue.use(CKEditor);

Vue.component('FormField', FormField);
Vue.component('Card', Card);

Vue.component('multiselect', Multiselect);
Vue.component('DateRangePicker', DateRangePicker);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('Draggable', draggable);
Vue.component('nl2br', Nl2br)

// Validation Rules
for (let rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: pt_BR.messages[rule]
  });
}

extend('cardNumber', {
  message: 'O campo {_field_} é inválido.',
  validate: value => Payment.fns.validateCardNumber(value)
});

extend('cardExpiry', {
  message: 'O campo {_field_} deve ter uma data futura.',
  validate: value => {
    let parts = value.split('/');
    return Payment.fns.validateCardExpiry(parts[0], parts.length > 1 ? parts[1] : '');
  }
});

extend('cardCvc', {
  message: 'O campo {_field_} deve ter 3 ou 4 dígitos.',
  validate: value => Payment.fns.validateCardCVC(value)
});

extend('moneyGreaterThanOne', {
  message: 'O campo {_field_} deve ser maior que R$ 1,00.',
  validate: value => value > 1
});

extend('valueLowerOrEqual100', {
  message: 'O campo {_field_} deve ser menor ou igual a 100,00.',
  validate: value => value <= 100.0
});

extend('valueLowerOrEqualValue', {
  params: ['targetValue', 'targetName'],
  validate(value, { targetValue }) {
    return value <= targetValue;
  },
  message: 'O campo {_field_} deve ser menor ou igual a {targetName}.',
});

extend('cpf', {
  ...CpfValidator,
  message: "O campo {_field_} possui um CPF inválido."
});

extend('cnpj', {
  ...CnpjValidator,
  message: "O campo {_field_} possui um CNPJ inválido."
});

extend('cpfOrCnpj', {
  message: 'O campo {_field_} possui um número inválido.',
  validate: value => CpfValidator.validate(value) || CnpjValidator.validate(value)
});

extend('instagramUsername', {
  message: 'O campo {_field_} possui um nome de usuário inválido.',
  validate: value => /^[\w](?!.*?\.{2})[\w.]{1,28}[\w]$/.test(value)
});

extend('slug', value => {
  if(/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)) {
    return true;
  }
  if(/^-/.test(value) || /-$/.test(value)) {
    return 'O campo {_field_} não pode começar nem terminar com "-".';
  }
  if(/\s/. test(value)) {
    return 'O campo {_field_} não pode ter espaços.';
  }
  let strippedValue = value.replace(/[a-z0-9-]/g, ''),
      invalidChars = [];
  for (let charIndex = 0; charIndex < strippedValue.length; charIndex++) {
    if(invalidChars.indexOf(strippedValue[charIndex]) === -1) {
      invalidChars.push(strippedValue[charIndex]);
    }
  }
  return 'O campo {_field_} possui caracteres inválidos: ' + invalidChars.join('');
});

if(process.env.VUE_APP_ENVIRONMENT == 'production') {
  Sentry.init({
    dsn: 'https://c49e6b85fdad426e888c822afcb6217c@sentry.io/1769232',
    integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
    environment: process.env.VUE_APP_ENVIRONMENT,
    release: 'consultaja-frontend@'+process.env.VUE_APP_VERSION
  });

  let gaConfig = {
    appName: 'Consulta Já',
    appVersion: process.env.VUE_APP_VERSION,
    trackingId: 'UA-154152750-1',
  };

  let mixpanelConfig = {
    token: 'f679e27dfe6162832fdadf3740a22c99'
  };

  Vue.use(VueMultianalytics, {
    modules: {
      ga: gaConfig,
      mixpanel: mixpanelConfig
    },
    routing: {
      vueRouter: router
    }
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
